import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../../services/api';
import './StocktakeList.css';

const StocktakeList = () => {
  const [stocktakes, setStocktakes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchStocktakes();
  }, []);

  const fetchStocktakes = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get('/stocktake');
      setStocktakes(response.data);
    } catch (error) {
      console.error('Error fetching stocktakes:', error);
      setError('Failed to load stocktakes');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (stocktakeId) => {
    if (window.confirm('Are you sure you want to delete this stocktake?')) {
      try {
        await apiClient.delete(`/stocktake/${stocktakeId}`);
        fetchStocktakes();
      } catch (error) {
        console.error('Error deleting stocktake:', error);
        setError('Failed to delete stocktake');
      }
    }
  };

  const getStatusBadge = (status) => {
    const statusClass = {
      'Pending': 'status-pending',
      'InProgress': 'status-in-progress',
      'Completed': 'status-completed'
    };
    return <span className={`status-badge ${statusClass[status] || ''}`}>{status}</span>;
  };

  if (loading) return <div className="loading">Loading stocktakes...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="stocktake-list">
      <div className="page-header">
        <h1>Stocktake Management</h1>
        <Link to="/inventory/stocktakes/new" className="btn btn-primary">
          Start New Stocktake
        </Link>
      </div>

      {stocktakes.length === 0 ? (
        <div className="no-data">
          <p>No stocktakes found.</p>
          <Link to="/inventory/stocktakes/new" className="btn btn-primary">
            Start Your First Stocktake
          </Link>
        </div>
      ) : (
        <div className="stocktake-grid">
          {stocktakes.map(stocktake => (
            <div key={stocktake.stocktakeId} className="stocktake-card">
              <div className="card-header">
                <h3>{stocktake.stocktakeName}</h3>
                {getStatusBadge(stocktake.status)}
              </div>
              <div className="card-body">
                <p className="description">{stocktake.description}</p>
                <div className="stocktake-info">
                  <div className="info-item">
                    <span className="label">Started:</span>
                    <span className="value">
                      {new Date(stocktake.startDate).toLocaleDateString()}
                    </span>
                  </div>
                  {stocktake.endDate && (
                    <div className="info-item">
                      <span className="label">Completed:</span>
                      <span className="value">
                        {new Date(stocktake.endDate).toLocaleDateString()}
                      </span>
                    </div>
                  )}
                  <div className="info-item">
                    <span className="label">Created by:</span>
                    <span className="value">{stocktake.createdByUser?.firstName} {stocktake.createdByUser?.lastName}</span>
                  </div>
                </div>
              </div>
              <div className="card-actions">
                <Link 
                  to={`/inventory/stocktakes/${stocktake.stocktakeId}`} 
                  className="btn btn-secondary"
                >
                  View Details
                </Link>
                {stocktake.status === 'InProgress' && (
                  <Link 
                    to={`/inventory/stocktakes/${stocktake.stocktakeId}/conduct`} 
                    className="btn btn-primary"
                  >
                    Continue Counting
                  </Link>
                )}
                {stocktake.status === 'Pending' && (
                  <button 
                    onClick={() => handleDelete(stocktake.stocktakeId)}
                    className="btn btn-danger"
                  >
                    Delete
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StocktakeList;